let ipPromise: Promise<string | null> | null = null;

const fetchIpify = (): Promise<string> =>
  fetch('https://api6.ipify.org?format=json', {
    signal: AbortSignal.timeout(5000),
  })
    .then((res) => {
      if (!res.ok) throw new Error(`ipify ${res.status}`);
      return res.json();
    })
    .then((data) => data.ip as string);

const fetchClientIp = (): Promise<string | null> => {
  if (!ipPromise) {
    ipPromise = fetchIpify()
      .catch(() => fetchIpify())
      .catch(() =>
        fetch('/api/client-ip')
          .then((res) => res.json())
          .then((data) => data.ip as string | null)
          .catch(() => null),
      );
  }
  return ipPromise;
};

/**
 * Eagerly starts fetching and caching the client IP on page load.
 * Call this once in _app.tsx so the value is ready before any POST requests fire.
 */
export const initClientIp = (): void => {
  if (typeof window !== 'undefined') {
    fetchClientIp();
  }
};

/**
 * Returns a promise resolving to the client's IP address (IPv6-normalized),
 * or null if unavailable or called server-side.
 * The result is cached for the lifetime of the page.
 */
export const getClientIp = (): Promise<string | null> => {
  if (typeof window === 'undefined') return Promise.resolve(null);
  return fetchClientIp();
};
